import ButtonAction from '../../../buttons/ButtonAction';
import { UpdateIconsOptions } from '../../../buttons/IconButtons';
import React, { useState } from 'react';
import PhotoPickerModal from './PhotoPickerModal';
import PickerFilePreview from '../PhotoWebcam/PickerFilePreview';
import CenterPhotoPicker from '../CenterPhotoPicker';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string id: component identifier
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component model
 * @param string actionModel: string with option "create" or "update", this comes from the ACTION_MODEL
 * @param model accept: file formats and sizes accepted by the component
 * @param boolean showBtnDelete: default value is true, must be set to false if selected files are not required
 * @param boolean required:  default value is false, must be set to true if the field is required
 * @param boolean disabled: for the disabled component
 * @param boolean showBtnCamera: default value is false, must be set to true if the camera option is needed
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param string titleModalEdit:  required if actionModel === ACTION_MODEL.UPDATE, title for modal
 * @param boolean showPreview: default value is true, must be set to false if preview visualization is not needed with the upload component
 * @param string classWith: for container size, used when centering the component (w-100, w-400px, other ), but it will always be centered
 * @param event handleDelete: required if actionModel === ACTION_MODEL.UPDATE and photo deletion is needed
 * @param string titleInput: title of the dashed-line component (file selection)
 * @param model typeSuggestions: required if showBtnCamera == true, the model must come from SUGGESTION_MODE_OPTION
 * @param boolean emptyFields: default value is false
 * @param state setDisplayModal: State management to ensure only one modal is visible at a time.
 * @param string btnNameUpdate: Name for the button that shows a preview of the file or photo, only used for the update action
 */
const PhotoPickerEdit = (
    {
        id,
        accept,
        photoPickerFile,
        setPhotoPickerFile,
        titleInput,
        handleDelete,
        showBtnDelete,
        disabled,
        showBtnCamera,
        validateFace,
        titleModalEdit,
        classWith,
        showPreview,
        actionModel,
        typeSuggestions,
        emptyFields,
        setDisplayModal,
        btnNameUpdate="upload_file"
    }) => {

    const [open, setOpen] = useState(false);

    const handleModal = () => {
        setOpen(true);
    };

    return (
        <>
            <CenterPhotoPicker classWith={classWith}>
                <PickerFilePreview
                    actionModel={actionModel}
                    photoPicker={photoPickerFile}
                    handleDelete={() => {
                        if(typeof handleDelete != 'undefined') {
                            handleDelete();
                        } else {
                            setPhotoPickerFile(prev => ({...prev,
                                selfieSrc: null,
                                fileSelected: null, // file
                                srcSelected: null, // file
                            }));
                        }
                    }}
                    accept={accept}
                    disabled={disabled}
                    emptyFields={emptyFields}
                    showBtnDelete={typeof handleDelete != 'undefined' || photoPickerFile?.fileSelected ||  photoPickerFile?.selfieSrc }
                />
                <div className='d-flex align-items-center mt-4 w-100'>
                    <ButtonAction
                        id='btn_szd_update'
                        name={btnNameUpdate}
                        className='btn-icon-upload-file w-100'
                        Icon={UpdateIconsOptions}
                        splitName={false}
                        onClick={() => {
                            if(setDisplayModal)
                                setDisplayModal("d-none");

                            handleModal();
                        }}
                        disabled={disabled}
                    />
                </div>
            </CenterPhotoPicker>

            { open &&
                <PhotoPickerModal
                    title={titleModalEdit ? titleModalEdit : 'update'}
                    show={open}
                    onHide={() => {
                        if(setDisplayModal)
                            setDisplayModal("");
                        setOpen(false)
                    }}
                    id={id}
                    accept={accept}
                    photoPickerFile={photoPickerFile}
                    setPhotoPickerFile={setPhotoPickerFile}
                    titleInput={titleInput}
                    disabled={disabled}
                    showBtnCamera={showBtnCamera}
                    validateFace={validateFace}
                    showBtnDelete={showBtnDelete}
                    classWith={classWith}
                    showPreview={showPreview}
                    typeSuggestions={typeSuggestions}
                />
            }

        </>);

}

export default PhotoPickerEdit;
